import React from 'react';
import { Tooltip } from 'antd';
import { FP610 } from '../../../services/p251Api';
import { Mode } from '../hooks/useP251Mode';

interface P251Permissions {
  canView: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canExport: boolean;
  canPrint: boolean;
  hasAnyPermission: boolean;
}

interface ActionBarProps {
  mode: Mode;
  isEditing: boolean;
  record: FP610 | null;
  currentIdx: number;
  allIdsLength: number;
  permissions: P251Permissions;
  onAdd: () => void;
  onModify: () => void;
  onDelete: () => void;
  onNavTo: (idx: number) => void;
  onExit: () => void;
}

/** 包裝按鈕：權限不足時顯示 Tooltip 提示 */
const PermBtn: React.FC<{
  allowed: boolean;
  disabled: boolean;
  className?: string;
  title?: string;
  onClick?: () => void;
  children: React.ReactNode;
}> = ({ allowed, disabled, className, title, onClick, children }) => {
  const btn = (
    <button
      className={className || 'btn'}
      disabled={disabled || !allowed}
      title={title}
      onClick={onClick}
    >
      {children}
    </button>
  );
  if (!allowed) {
    return <Tooltip title="權限不足">{btn}</Tooltip>;
  }
  return btn;
};

const ActionBar: React.FC<ActionBarProps> = ({
  mode, isEditing, record, currentIdx, allIdsLength, permissions,
  onAdd, onModify, onDelete, onNavTo, onExit,
}) => {
  const { canView, canCreate, canEdit, canDelete } = permissions;

  return (
    <div className="action-bar">
      {/* Navigation */}
      <div className="action-group">
        <PermBtn allowed={canView} disabled={isEditing || currentIdx <= 0} onClick={() => onNavTo(0)}>
          最前
        </PermBtn>
        <PermBtn allowed={canView} disabled={isEditing || currentIdx <= 0} onClick={() => onNavTo(currentIdx - 1)}>
          上一筆
        </PermBtn>
        <PermBtn allowed={canView} disabled={isEditing || currentIdx >= allIdsLength - 1} onClick={() => onNavTo(currentIdx + 1)}>
          下一筆
        </PermBtn>
        <PermBtn allowed={canView} disabled={isEditing || currentIdx >= allIdsLength - 1} onClick={() => onNavTo(allIdsLength - 1)}>
          最後
        </PermBtn>
      </div>

      <div className="action-separator" />

      {/* CRUD */}
      <div className="action-group">
        <PermBtn
          allowed={mode === 'edit' ? canEdit : canCreate}
          disabled={false}
          className={isEditing ? 'btn btn-primary' : 'btn'}
          onClick={onAdd}
        >
          {isEditing ? '存檔' : '新增'}
        </PermBtn>
        <PermBtn
          allowed={canEdit}
          disabled={!record && !isEditing}
          onClick={onModify}
        >
          {isEditing ? '還原' : '修改'}
        </PermBtn>
        <PermBtn
          allowed={canDelete}
          disabled={isEditing || !record}
          className="btn btn-danger"
          onClick={onDelete}
        >
          刪除
        </PermBtn>
      </div>

      <div className="action-separator" />

      {/* Exit */}
      <div className="action-group">
        <button className="btn" onClick={onExit}>
          離開
        </button>
      </div>
    </div>
  );
};

export default ActionBar;
